import { PDF_VIEWER_NARROW_SCREEN_BREAKPOINT } from '../../PdfViewer.constants'

export function checkIsNarrowScreen() {
  return window.matchMedia(PDF_VIEWER_NARROW_SCREEN_BREAKPOINT).matches
}

// a panel without its toolbar button could never be closed again
export function checkIsPdfViewerPanelOpenByDefault({
  defaultOpenPanels,
  tool,
  tools,
}) {
  return tools.includes(tool) && defaultOpenPanels.includes(tool)
}
